import { activeTenantServiceWorker, registerTenantServiceWorker } from '@/pwa/register.ts'
import { getSupabaseClient } from '@/lib/supabase/client.ts'

function deviceStorageKey(): string { return 'client-notification-device:v1' }
function installationId(): string {
  const existing = localStorage.getItem(deviceStorageKey())
  if (existing) return existing
  const id = crypto.randomUUID()
  localStorage.setItem(deviceStorageKey(), id)
  return id
}

async function saveDevice(slug: string, device: PushSubscription): Promise<void> {
  const keys = device.toJSON().keys
  if (!keys?.['p256dh'] || !keys['auth']) throw new Error('Не удалось подключить устройство')
  const { error } = await getSupabaseClient().rpc('subscribe_client_device', {
    p_slug: slug, p_endpoint: device.endpoint, p_p256dh: keys['p256dh'], p_auth: keys['auth'], p_device_id: installationId(),
  })
  if (error) throw new Error('Не удалось сохранить подписку. Попробуйте ещё раз.')
}

export async function clientDeviceSubscribed(slug: string): Promise<boolean> {
  if (!('Notification' in globalThis) || Notification.permission !== 'granted') return false
  const registration = await registerTenantServiceWorker()
  const device = await registration?.pushManager?.getSubscription()
  if (!device) return false
  const { data, error } = await getSupabaseClient().rpc('client_device_subscription', {
    p_slug: slug, p_endpoint: device.endpoint,
  })
  if (error) throw new Error('Не удалось проверить подписку')
  // Adopt the installation ID only after existing explicit server consent.
  if (data === true) await saveDevice(slug, device)
  return data === true
}

// Called only from an explicit user action, after OS permission is granted.
export async function subscribeClientDevice(slug: string, vapid: string): Promise<void> {
  const registration = await activeTenantServiceWorker()
  if (!registration || Notification.permission !== 'granted') throw new Error('Разрешите уведомления на устройстве')
  const decoded = atob(vapid.replace(/-/g, '+').replace(/_/g, '/'))
  const key = new Uint8Array(decoded.length)
  for (let i = 0; i < decoded.length; i++) key[i] = decoded.charCodeAt(i)
  const device = await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key.buffer })
  await saveDevice(slug, device)
}

export async function unsubscribeClientDevice(slug: string | null): Promise<void> {
  const id = localStorage.getItem(deviceStorageKey())
  if (id) {
    const { error } = await getSupabaseClient().rpc('unsubscribe_client_installation', { p_slug: slug, p_device_id: id })
    if (error) throw new Error('Не удалось отключить уведомления. Проверьте интернет и повторите.')
    return
  }
  if (!('serviceWorker' in navigator)) return
  if (!('Notification' in globalThis) || Notification.permission !== 'granted') return
  const registration = await registerTenantServiceWorker()
  const device = await registration?.pushManager?.getSubscription()
  if (!device) return
  const { error } = await getSupabaseClient().rpc('unsubscribe_client_device', { p_slug: slug, p_endpoint: device.endpoint })
  if (error) throw new Error('Не удалось отключить уведомления. Проверьте интернет и повторите.')
  // Do not unsubscribe PushManager: owner/guest subscriptions may use it too.
}
